export enum AnswerResponseProgress {
  IN_PROGRESS = 'IN_PROGRESS',
  NO = 'NO',
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  YES = 'YES',
}

export const getAnswerDisplayText = (value: AnswerResponseProgress): string => {
  switch (value) {
    case AnswerResponseProgress.YES:
      return 'Yes';
    case AnswerResponseProgress.NO:
      return 'No';
    case AnswerResponseProgress.IN_PROGRESS:
      return 'In progress';
    case AnswerResponseProgress.NOT_APPLICABLE:
      return 'Not applicable';
    default:
      return value;
  }
};
